<template>
  <div>
    <a-drawer :title="`${actType}标题组`" :width="720" :visible="showForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">

        <a-form-model-item label="所属主体" prop="corporation_ids">
          <a-select mode="multiple" show-search allow-clear placeholder="请选择" v-model="model.corporation_ids"
            option-filter-prop="children">
            <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id">
              {{ corporation.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="标题组名称" prop="name">
          <a-input v-model="model.name" />
        </a-form-model-item>

        <a-form-model-item label="标题" prop="titles">
          <a-textarea v-model="titles" placeholder="请填写标题" :auto-size="{ minRows: 15 }" />
        </a-form-model-item>


      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
